import React from 'react'
import Heading from './Heading'
import Section from './blogs_section'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import Blog from './web_blogs.js/backend-of-website'
import Footer from './footer'

export default function Main() {
    return (
        <>
            <Heading />
            <Section/><br /><br />
            <Footer/>
        </>
    )
}